import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody } from '@vds/modals';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import IPIModalBody from './IPIModalBody';
import { getIPIData, getIPILoaded } from '../@Redux/selectors';
import * as actionTypes from '../actionTypes';

// Important Plan Information Modal
const IPIModal = (props) => {
  const dispatch = useDispatch();
  const ipiData = useSelector((state) => getIPIData(state), shallowEqual);
  const ipiLoaded = useSelector((state) => getIPILoaded(state), shallowEqual);

  useEffect(() => {
    if (!ipiLoaded) {
      dispatch({ type: actionTypes.GET_IMPORTANT_PLAN_INFO });
    }
  });

  return (
    <>
      {ipiLoaded && (
        <Modal
          opened={props.opened}
          onOpenedChange={props.onOpenedChange}
          ariaLabel={props.ariaLabel}
          data-track='{"type": "link","name": "important plan information close","data":{"page":{"detail":"important plan information modal" }}}'
        >
          <ModalBody>{ipiData ? <IPIModalBody modalContent={ipiData} /> : <></>}</ModalBody>
        </Modal>
      )}
    </>
  );
};

IPIModal.propTypes = {
  opened: PropTypes.bool,
  onOpenedChange: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default React.memo(IPIModal);
